import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import { stafflistGet, userDetailsGet, staffStatusUpdateApi, staffCreatePost, staffCreatePatch, individualUserApiGet, allHotelsListApiGet, staffDeleteApi, getHotelBranchListGet, getRoomTypeListGet, roleListGetApi, staffHistoryGet } from '../Model/UserModel';

import * as Store from '../../../../../store'
let version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";

export const staffList = async (data, userType = 'admin') => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}`, data);
    return stafflistGet(response);
};

export const user_Details = async (id, data, userType = 'admin') => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}/${id}`, data);
    return userDetailsGet(response);
};

export const staffStatusUpdate = async (id, data, userType = 'admin') => {
    const response = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}/${id}`, data);
    return staffStatusUpdateApi(response);
};

export const staffCreate = async (data, id, type, userType = 'admin') => {
    if (type == 'post') {
        const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}`, data);
        return staffCreatePost(response);
    } else {
        const response_1 = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}/${id}`, data);
        return staffCreatePatch(response_1);
    }
};

export const individualUser = async (id, data, userType) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}/${id}`, data);
    return individualUserApiGet(response);
};

export const allHotelsList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org`, data);
    return allHotelsListApiGet(response);
};

export const staffDelete = async (data) => {
    const response = await del(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users`, data);
    return staffDeleteApi(response);
};

export const getHotelBranchList = async (data, userType = "admin", hotelId) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    let response = "";
    if (hotelId == "") {
        response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? 'org_branch' : 'org_branch'}`, data);
    } else {
        response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org_branch`, data);
    }

    return getHotelBranchListGet(response);
};

export const getStoreList = async (data, userType = "admin", hotelId, storeSlack = "") => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    let response = "";
    // Use new store-hierarchy endpoint if storeSlack is provided
    if (storeSlack) {
        response = await get(`${process.env.EXTENDED_URL}store-hierarchy/${storeSlack}/child-stores`, data);
    } else {
        // Fallback to original logic
        if (hotelId == "") {
            response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? 'org_branch' : 'org_branch'}`, data);
        } else {
            response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org_branch`, data);
        }
    }

    return getHotelBranchListGet(response);
};
export const getRoomTypeList = async (data) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${version}/org_room_types`, data);
    return getRoomTypeListGet(response);
};

export const roleListGet = async (data, userType = '') => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles`, data);
    return roleListGetApi(response);
};

export const getStaffHistory = async (data,userType='admin') => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}${['agent', 'agent_staff'].includes(userType) ? `${version}/users` : 'users'}/user_history`, data);
    return staffHistoryGet(response);
};
